import axios from 'axios';

// Model adı env'den okunabilir; varsayılan güncel GA flash modeli.
// 404 "model bulunamadı" alırsan REACT_APP_GEMINI_MODEL=gemini-2.5-flash dene.
const MODEL = process.env.REACT_APP_GEMINI_MODEL || 'gemini-3.5-flash';
const API_ENDPOINT = `https://generativelanguage.googleapis.com/v1beta/models/${MODEL}:generateContent`;

export async function predictWithGoogleAI(prompt) {
  const apiKey = process.env.REACT_APP_GOOGLE_AI_API_KEY;

  if (!apiKey) {
    throw new Error('API anahtarı tanımlanmamış');
  }

  try {
    const response = await axios.post(
      `${API_ENDPOINT}?key=${apiKey}`,
      {
        contents: [
          {
            parts: [
              { text: prompt }
            ]
          }
        ]
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    // API yanıtının yapısına göre bu kısmı ayarlayın
    return response.data.candidates[0].content.parts[0].text;
  } catch (error) {
    console.error('AI tahmininde bir hata oluştu:', error);
    if (error.response) {
      console.error('Yanıt verisi:', error.response.data);
      console.error('Durum kodu:', error.response.status);
      console.error('Yanıt başlıkları:', error.response.headers);
    } else if (error.request) {
      console.error('İstek:', error.request);
    } else {
      console.error('Hata mesajı:', error.message);
    }
    throw error;
  }
}